
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObcCapacitor as ObcCapacitorElement} from '@oicl/openbridge-webcomponents/dist/automation/capacitor/capacitor.js';
 
 
 

 
 export const ObcCapacitor = createComponent({
   react: React,
   tagName: 'obc-capacitor',
   elementClass: ObcCapacitorElement,
   events: {
     
   }
  });
 
 